var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.375 19.5V12.75C32.375 10.7609 31.5848 8.85322 30.1783 7.4467C28.7718 6.04018 26.8641 5.25 24.875 5.25H12.125C10.1359 5.25 8.22822 6.04018 6.8217 7.4467C5.41518 8.85322 4.625 10.7609 4.625 12.75V23.25C4.625 24.2349 4.81899 25.2102 5.1959 26.1201C5.57281 27.0301 6.12526 27.8569 6.8217 28.5533C8.22822 29.9598 10.1359 30.75 12.125 30.75H21.515",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01465 25.4999L9.12465 20.6999C9.66441 20.1639 10.3728 19.8307 11.13 19.7569C11.8871 19.6831 12.6465 19.8732 13.2796 20.2949C13.9128 20.7167 14.6722 20.9068 15.4293 20.833C16.1865 20.7592 16.8949 20.426 17.4346 19.8899L20.9296 16.3949C21.9339 15.3873 23.2635 14.7693 24.6812 14.6511C26.0989 14.533 27.5125 14.9224 28.6696 15.7499L32.3746 18.6149M12.5146 15.2549C12.8416 15.253 13.165 15.1866 13.4664 15.0597C13.7677 14.9327 14.0411 14.7476 14.271 14.515C14.5008 14.2824 14.6825 14.0068 14.8058 13.704C14.9292 13.4011 14.9916 13.0769 14.9896 12.7499C14.9877 12.423 14.9213 12.0996 14.7944 11.7982C14.6674 11.4969 14.4823 11.2235 14.2497 10.9936C14.0171 10.7638 13.7415 10.5821 13.4387 10.4587C13.1358 10.3354 12.8116 10.273 12.4846 10.2749C11.8243 10.2789 11.1925 10.5451 10.7283 11.0149C10.2642 11.4846 10.0057 12.1196 10.0096 12.7799C10.0136 13.4403 10.2798 14.0721 10.7496 14.5363C11.2193 15.0004 11.8543 15.2589 12.5146 15.2549Z",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5605 22.5V30",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 25.6574L29.0496 22.7069C28.9857 22.6421 28.9096 22.5907 28.8256 22.5556C28.7417 22.5205 28.6516 22.5024 28.5606 22.5024C28.4696 22.5024 28.3795 22.5205 28.2956 22.5556C28.2116 22.5907 28.1355 22.6421 28.0716 22.7069L25.1211 25.6574",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image-upload.5c7d4c2d9c3ace950e559f6dc8474890.svg";
export { ForwardRef as ReactComponent };